import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { load } from '@cashfreepayments/cashfree-js';

export const buyApi = createAsyncThunk(
  "buy_fintso",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.customerName = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/fintso_transactions/buy", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      // console.log("customerName", response.data);
      return response.data;
    }
  }
);

const buySlice = createSlice({
  name: "buy_fintso",
  initialState: {
    buy: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(buyApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(buyApi.fulfilled, (state, action) => {
        state.buy = action.payload;
        state.loading = false;
      })
      .addCase(buyApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default buySlice.reducer;

